import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';
import { config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ExamScheduleService {
  
  private apiUrl = `${config.examApiBaseUrl}/call`;
  private paidCoursesUrl = `${config.examApiBaseUrl}/exam/paid-courses`;
  private attendanceNumberUrl = `${config.examApiBaseUrl}/exam/send-attendance-number`;
  
  constructor(private http: HttpClient, private permissionsService: PermissionsService) { }
   
  getTraineeDetails(identification: string): Observable<any> { // From TrainingApp
    return this.http.get<any>(`${this.paidCoursesUrl}/${identification}`);
  }

  saveTraineeDetails(traineeInfo: any): Observable<any> {
    const body = {
      procedureName: 'SaveTraineeDetails',
      params: {
        BookingID: traineeInfo.bookingId,
        BookingDate: traineeInfo.bookingDate,
        BookingType: traineeInfo.bookingType,
        ScheduleID: traineeInfo.scheduleId,
        SessionDate: traineeInfo.sessionDate,
        CourseID: traineeInfo.courseId,
        CourseName: traineeInfo.courseName,
        CourseLang: traineeInfo.courseLang,
        PaymentID: traineeInfo.paymentId,
        PaidAmount: traineeInfo.paidAmount,
        PaymentDate: traineeInfo.paymentDate,
        Status: traineeInfo.traineeExamStatus,
        IDNumber: traineeInfo.traineeID,
        TraineeName: traineeInfo.traineeName,
        ExamAttendanceNumber: traineeInfo.examAttendanceNumber,
        Gender: traineeInfo.gender,
        BranchName: traineeInfo.branchName,
        CityName: traineeInfo.cityName,
        BranchID: traineeInfo.branchId,
        PhoneNumber: traineeInfo.phone,
        CreatedBy: this.permissionsService.getUserId()
      },
    };
    return this.http.post<any>(this.apiUrl, body, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getTraineeDetailsByID(identification: string): Observable<any> { // From ExamApp
    const body = {
      procedureName: 'GetTraineeDetailsByID',
      params: {
        IDNumber: identification,
      },
    };
    return this.http.post<any>(this.apiUrl, body, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getTraineeResult(identification: string): Observable<any> { // From ExamApp
    const body = {
      procedureName: 'GetTraineeExamDetailsByID',
      params: {
        IDNumber: identification,
      },
    };
    return this.http.post<any>(this.apiUrl, body, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  sendExamAttendanceNumber(payload: { id: number, attendanceNumber: string }): Observable<any> {
    return this.http.post<any>(this.attendanceNumberUrl, payload);
  }
  
  
}
